export default __webpack_public_path__ + "static/media/blueArrow.7765a8e1.svg";